import * as Yup from "yup";
import i18n from "../i18n";

export const MusterPointsConfigurationSchema = Yup.object({
  musterPointNameEn: Yup.string().required(
    i18n.language === "en"
      ? "Muster Point Name (English) is required"
      : "اسم نقطة التجمع (باللغة الإنجليزية) مطلوب",
  ),
  musterPointNameAr: Yup.string().required(
    i18n.language === "en"
      ? "Muster Point Name (Arabic) is required"
      : "اسم نقطة التجمع (باللغة العربية) مطلوب",
  ),
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required" : "الموقع مطلوب",
  ),
  musterPointLink: Yup.string().required(
    i18n.language === "en" ? "Link is required" : "الرابط مطلوب",
  ),
  musterPointPhoto: Yup.mixed().when("$havePhoto", {
    is: true,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema.required(
        i18n.language === "en" ? "Photo is required" : "الصورة مطلوبة",
      ),
  }),
});
